import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Modal, Button, Image } from 'react-bootstrap';

/* import from view folder */
import Workshops from "../../../views/dashboard/workshops";

/* import function from store folder */
import { resetModel } from '../../../store/components/modelSlice';

/* import API function from services folder */
import { UpdateDriver } from "../../../services/common";
import { FetchDriverDetail } from "../../../services/dashboard/reserve";

const DriverRevise = () => {
    const dispatch = useDispatch();
    const [initialFormState, setInitialState] = useState({
        account: '',
        mobilePhone: '',
        name: '',
        photoUrl: '',
        status: '',
        newPassword: '',
        workshops: []
    });
    const [uploadImage, setUploadImage] = useState(null);
    const [source, setSource] = useState(initialFormState);
    const [formChangeState, setFormChangeState] = useState(false);
    const [isUpdatePassword, setIsUpdatePassword] = useState(false);
    const { data } = useSelector(state => state.model);
    const cancelHandler = () => dispatch(resetModel());

    const confirmation = () => {
        const request = unitySource();
        
        UpdateDriver(request).then(response => {
            cancelHandler();
        })
        .catch( error => console.log(error));
    };

    const unitySource = () => {
        const formData = new FormData();
        const keys = Object.keys(source);
        
        keys.forEach( key => {
            const isArray = Array.isArray(source[key]);
            
            if (isArray) {
                for (let index = 0; index < source[key].length; index++) {
                    formData.append(`${key}[${index}]`, source[key][index]);
                }
            }
            else if (key === 'photoUrl' && uploadImage)
                formData.append('photo', uploadImage);
            else
                formData.append(key, source[key]);
        });

        return formData;
    };

    const handleChange = ({ target: { name, value, files } }) => {
        let changed = { [name]: value };

        if (name === 'updatePassword') {
            const isUpdate = !!Number(value);
            
            if (isUpdate) changed = {};
            else changed = { newPassword: '' };

            setIsUpdatePassword(isUpdate);
        }
        else if (name === 'status') changed[name] = Number(value);
        else if (name === 'photo') {
            const file = files[0];

            setUploadImage(file);

            return handleUploadImage(file);
        }

        setSource( items => ({ ...items, ...changed }));
    };

    const handleUploadImage = file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setSource( items => ({ ...items, photoUrl: reader.result }));
        }
    };

    useEffect(() => {
        FetchDriverDetail({ account: data }).then( response => {
            setSource({ ...response, newPassword: '' });
            setInitialState({ ...response, newPassword: '' });
        })
        .catch( error => console.log(error) );
    }, [])

    useEffect(() => {
        const isFormChanged = JSON.stringify(initialFormState) !== JSON.stringify(source);
        
        setFormChangeState(isFormChanged)
    }, [ source ])

    return (
        <Modal className='driver-model' size='lg' show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-title">個人資料</div>
                <div className="message-container">
                    <label className="driver-photo">
                        <input type="file" name='photo' accept='.png' hidden onChange={ handleChange } />
                        <Image src={ source.photoUrl } />
                    </label>
                    <Form className='model-form-container'>
                        <Form.Group className='model-form-group'>
                            <Form.Label>司機帳號</Form.Label>
                            <Form.Control className='model-form-content' name='account' value={ source.account } disabled  />
                        </Form.Group>
                        <Form.Group className='model-form-group'>
                            <Form.Label>姓名</Form.Label>
                            <Form.Control className='model-form-content' name='name' defaultValue={ source.name } onChange={ handleChange } />
                        </Form.Group>
                        <Form.Group className='model-form-group'>
                            <Form.Label>手機</Form.Label>
                            <Form.Control className='model-form-content' name="mobilePhone" defaultValue={ source.mobilePhone } disabled />
                        </Form.Group>
                        <Form.Group className='model-form-group'>
                            <Form.Label>啟用狀態</Form.Label>
                            <Form.Select className='model-form-content' name='status' value={ source.status } onChange={ handleChange }>
                                <option value="0">未啟用</option>
                                <option value="1">啟用</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className='model-form-group'>
                            <Form.Label>更新密碼</Form.Label>
                            <Form.Select className='model-form-content' name="updatePassword" defaultValue={ 0 } onChange={ handleChange }>
                                <option value="0">否</option>
                                <option value="1">是</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className='model-form-group'>
                            <Form.Label>新密碼</Form.Label>
                            <Form.Control className='model-form-content' name='newPassword' value={ source.newPassword } disabled={ !isUpdatePassword } onChange={ handleChange } />
                        </Form.Group>
                        <Form.Group className='model-form-group'>
                            <Form.Label>所屬保修廠</Form.Label>
                            <Workshops values={ source.workshops } onChange={ handleChange } />
                        </Form.Group>
                    </Form>
                </div>
                <div className="button-container">
                    <Button variant="secondary" data-shadow onClick={ cancelHandler }>關閉</Button>
                    <Button variant="primary" data-shadow disabled={ !formChangeState } onClick={ confirmation }>儲存</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default DriverRevise;